import { useTranslation } from "react-i18next";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import { Fragment, useEffect, useRef, useState, useCallback } from "react";
import { NavCar } from "./hover/navCar";
import { NavMaintenance } from "./hover/navMaintenance";
import { NavAbout } from "./hover/navAbout";
import { NavContact } from "./hover/navContact";
import { useDispatch, useSelector } from "react-redux";
import { list } from "cart-localstorage";
import Popup from "../../User/popup";
import axios from "axios";
import { changeCount } from "../../_redux/slices/cartSlice";
import SignIn from "../../User/signIn";
import SignUp from "../../User/signUp";
import ResetPassword from "../../User/resetPassword";
import LoginValidation from "../../User/loginValidation";
import AdvancedSearch from "../_input/advancedSearch";
import _ from "lodash";
import { numberFormat } from "../../utils/currencyFormatter";
import config from "../../configuration/config";
import { Price } from "../../components/__simple/_price";
import { Base64 } from "js-base64";
import Joi from "joi";
import { GetMessages } from "../../utils/validation";
import { setReduxBrands } from "../../_redux/slices/dataSlice";
import NotificationComponent from "../../components/NotificationComponent";
import CartIconWithPopover from "../../pages/parts/components/CartPopoverContent"; // عدّل المسار حسب مكان الملف
import LogoutButtonV7 from "../logout/LogoutButtonV7";
import { User_Data_Key, getData } from "../../utils/localStorageManager";

function Navbar({ popupShow, showCallCenter = true, partNavbar = false }) {
  const { t: trans, i18n } = useTranslation(["common", "form", "language", "info", "home", "cartFile", "navbar"]);
  let lang = (i18n.language || "ar").toLowerCase().slice(0, 2);
  let languageDir = "language-" + lang;

  const dispatch = useDispatch();
  const location = useLocation();
  const reduxBrands = useSelector((state) => state.apiData.data.reduxBrands); // Access Redux state
  const navRef = useRef(null);
  const popRef = useRef(null);
  const [navTop, setNavTop] = useState(-16);
  const [navFlex, setNavFlex] = useState(false);
  const lastScrollYRef = useRef(0);
  const headerFixedRef = useRef(true);
  const [onhamburger, setOnhamburger] = useState(false);

  const [showNav, setShowNav] = useState(null);
  const [showLangPanel, setShowLangPanel] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check local storage for theme preference
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      setIsDarkMode(true);
      document.documentElement.classList.add('dark');
      document.body.classList.add('dark');
    }
  }, []);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    if (!isDarkMode) {
      document.documentElement.classList.add('dark');
      document.body.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      document.body.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  const history = useHistory();
  const headerFixed = useSelector((state) => state.entities.nav.isFixed);

  useEffect(() => {
    headerFixedRef.current = headerFixed;
  }, [headerFixed]);

  const headerIcons = useSelector((state) => state.entities.nav.iconsBlack);
  const cartCount = useSelector((state) => state.entities.cart.count);
  const notifications = useSelector((state) => state.notifications);
  const notificationCount = notifications?.filter(n => !n.read).length || 0;

  const [brands, setBrands] = useState([]);
  const [searchPopup, setSearchPopup] = useState(false);
  const [showCartNotification, setShowCartNotification] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showAcctPanel, setShowAcctPanel] = useState(false);
  const [showCartPanel, setShowCartPanel] = useState(false);
  const timerRef = useRef(null);
  const [activePopUpModel, setActivePopUpModel] = useState({
    tab: 1,
    title: "sign-in",
  });
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    if (localStorage.getItem("isAuthenticated")) {
      try {
        const data = getData(User_Data_Key, true);
        if (data) {
          setUserInfo(JSON.parse(data));
        }
      } catch (err) {
        console.error("Error parsing user data", err);
      }
    }
  }, []);

  // Mobile Bottom Sheet Drag logic
  const [startY, setStartY] = useState(0);
  const [currentY, setCurrentY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const handleTouchStart = (e) => {
    if (window.innerWidth > 992) return;
    setStartY(e.touches[0].clientY);
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const diff = e.touches[0].clientY - startY;
    if (diff > 0) setCurrentY(diff);
  };

  const handleTouchEnd = () => {
    if (currentY > 100) {
      setShowAcctPanel(false);
      setShowCartPanel(false);
    }
    setIsDragging(false);
    setCurrentY(0);
  };
  function getCartList() {
    var types = ["car", "service"];
    const lowerTypes = types.map((t) => t.toLowerCase());
    const items = list() || []; // تأكد من أنها مصفوفة
    return items.filter((item) => lowerTypes.includes(item.Type?.toLowerCase()));
  }
  const handleTabChange = (tab) => {
    setActivePopUpModel(tab);
  };

  const handlePopupStatus = (status) => {
    setShowPopup(status);
  };

  // useEffect(() => {
  //     console.log('showNav>>>>>>>>>>>>>>>>>>>>>>>', showNav);

  // }, [showNav])

  useEffect(() => {
    function handleClickOutside(event) {
      if (popRef.current && !popRef.current.contains(event.target) && showCartNotification === true) {
        setShowCartNotification(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCartNotification]);

  const schemaNavContact = Joi.object({
    fullName: Joi.string().required().messages(GetMessages()),
    phone: Joi.string().min(12).required().messages(GetMessages()),
    email: Joi.string()
      .email({ minDomainSegments: 2, tlds: { allow: false } })
      .required()
      .messages(GetMessages()),
    subject: Joi.string().required().messages(GetMessages()),
    messageContent: Joi.string().required().messages(GetMessages()),
  });

  const countlist = getCartList().length;
  const [addEvent, setaddEvent] = useState(false);
  useEffect(() => {
    window.addEventListener("storage", listenForStorage);
    window.addEventListener("cart:changed", listenForStorage);

    if (addEvent == true) {
      try {
        window.dispatchEvent(new Event("storage"));
      } catch (error) { }
    }

    setaddEvent(true);

    return () => {
      window.removeEventListener("storage", listenForStorage);
      window.removeEventListener("cart:changed", listenForStorage);
    };
  }, [addEvent]);

  const listenForStorage = (v) => {
    if (countlist != getCartList().length && showCartNotification != true && getCartList().length > 0) {
      setShowCartNotification(true);
    }

    if (getCartList().length <= 0) {
      setShowCartNotification(false);
    }
    Account();
    dispatch(changeCount({ count: getCartList().length }));
    return () => {
      dispatch(changeCount({ count: getCartList().length }));
    };
  };

  useEffect(() => {
    window.addEventListener("storage", listenForStorageToCount);
    window.addEventListener("cart:changed", listenForStorageToCount);

    try {
      window.dispatchEvent(new Event("storage"));
    } catch (error) { }

    return () => {
      window.removeEventListener("storage", listenForStorageToCount);
      window.removeEventListener("cart:changed", listenForStorageToCount);
    };
  }, []);
  const listenForStorageToCount = () => {
    Account();
    dispatch(changeCount({ count: getCartList().length }));
    return () => {
      dispatch(changeCount({ count: getCartList().length }));
    };
  };

  useEffect(() => {
    if (window.innerWidth < 577) {
      setNavTop(-1);
    } else {
      setNavTop(-16);
    }
  }, [window.innerWidth]);

  const [TotalTax, SetTotalTax] = useState(0);
  const [TotalDiscount, SetTotalDiscount] = useState(0);
  const [SumItemTotal, setSumItemTotal] = useState(0);
  const [SubTotal, setSubTotal] = useState(0);
  const [fullTotal, setfullTotal] = useState(0);
  const [MiniDownPayment, setMiniDownPayment] = useState(0);
  //Accounting for all items
  function Account() {
    let currentTotalTax = _.sum(
      getCartList().map((p) => {
        return (100 / 115) * ((p?.Type?.toLowerCase() == "car" ? p.price : p.price) * p.quantity) * 0.15;
      }),
    );
    SetTotalTax(currentTotalTax);

    // let currentTotalDiscount = _.sum(getCartList().map((p) => {
    //     return calculateDiscount(p);
    // }));
    // SetTotalDiscount(currentTotalDiscount);

    let currentSumItemTotal = _.sum(
      getCartList().map((p) => {
        return (p?.Type?.toLowerCase() == "car" ? (p.MiniDownPayment ? p.MiniDownPayment : p.price) : p.price) * p.quantity;
      }),
    );
    setSumItemTotal(currentSumItemTotal);
    let currentSumfullTotal = _.sum(
      getCartList().map((p) => {
        return p.price * p.quantity;
      }),
    );

    setfullTotal(currentSumfullTotal);
    let currentSubTotal = _.sum(
      getCartList().map((p) => {
        return (p?.Type?.toLowerCase() == "car" ? (p.MiniDownPayment ? p.MiniDownPayment : p.price) : p.price) * p.quantity;
      }),
    );
    setSubTotal(currentSubTotal);

    let currentMiniDownPayment = _.sum(
      getCartList().map((p) => {
        return p.MiniDownPayment && p.MiniDownPayment != 0
          ? p.MiniDownPayment * p.quantity
          : (p?.Type?.toLowerCase() == "car" ? (p.MiniDownPayment ? p.MiniDownPayment : p.price) : p.price) * p.quantity;
      }),
    );
    setMiniDownPayment(currentMiniDownPayment);
  }

  // useEffect(() => {

  //     console.log("getCartList().length>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", getCartList().length)
  //     console.log("getlistCart>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", getlistCart)
  //     console.log("showCartNotification>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", showCartNotification)
  //     if (getlistCart == true && showCartNotification != true) {

  //         // setShowCartNotification(true);

  //     }
  //     Account();
  //     setgetlistCart(true);
  //     dispatch(
  //         changeCount({ count: getCartList().length })
  //     )
  //     return () => {
  //         dispatch(
  //             changeCount({ count: getCartList().length })
  //         )
  //     };

  // }, [cartCount]);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        if ("caches" in window) {
          let url = "brands-" + lang;
          const cacheStorage = await caches.open("HJWeb");
          const cachedResponse = await cacheStorage.match(url);
          let data = await cachedResponse?.json();
          if (data && data?.brands && data?.brands?.length > 0) setBrands(data.brands);
        }
      } catch (error) { }

      try {
        const res = await axios.request({
          baseURL: config.controllURL,
          url: lang + "/api/brands/brands",
          method: "get",
        });

        setBrands(res.data.brands);
        const data22 = new Response(JSON.stringify(res.data));

        if ("caches" in window) {
          caches.open("HJWeb").then((cache) => {
            cache.put("brands-" + lang, data22);
          });
        }
      } catch (error) { }
    };

    fetchBrands();
  }, [lang]);

  useEffect(() => {
    // Reset nav state on navigation
    setNavFlex(false);
    if (window.innerWidth < 577) {
      setNavTop(-1);
    } else {
      setNavTop(-16);
    }
  }, [location.pathname]);

  const handleScroll = useCallback(() => {
    if (headerFixedRef.current) {
      const currentScrollY = window.scrollY;

      // Original Logic: 
      // Show when scrolling down past 300px (lastScrollYRef is effectively 0 here)
      if (currentScrollY - 300 > 0) {
        setNavFlex(true);
        setNavTop(-1);
      } else {
        // Default / Hidden states
        if (window.innerWidth < 577) {
          setNavTop(-1);
        } else {
          setNavTop(-18);
        }

        // Hide when scrolling back up near the top (below 200px)
        if (currentScrollY <= 200) {
          setNavFlex(false);
        }
      }
    } else {
      setNavFlex(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);
  const [showedListNav, setShowedListNavShowNav] = useState([]);

  function show(section) {
    setShowNav(null);
    if (section && !showedListNav.includes(section)) {
      timerRef.current = setTimeout(() => {
        handleMouseEnter(section);
        setShowNav(section);
      }, 700); // 2000 milliseconds = 2
    } else {
      setShowNav(section);
    }
  }

  function onMouseOut() {
    setShowNav(null);
    handleMouseLeave();
  }

  const handleMouseEnter = (section) => {
    if (section && !showedListNav.includes(section)) {
      showedListNav.push(section);
    }
  };

  const handleMouseLeave = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  useEffect(() => {
    const syncBrands = async () => {
      if (reduxBrands?.length > 0 && brands?.length <= 0) {
        setBrands(reduxBrands);
      }
      if (brands?.length > 0) {
        dispatch(setReduxBrands(brands));
      }
    };
    syncBrands();
  }, [reduxBrands, brands, dispatch]);
  return (
    <Fragment>
      <header className={"z-50 mb-8 md:mb-0 lg:mb-0 " + languageDir + " " + (headerFixed ? " " : " header-absolute ")}>
        {/* CallCenter is now integrated inside the navbar icons */}

        <div className={"hide-xs nav-height " + (navFlex ? navFlex : "hidden")}>
          <span style={{ opacity: "0" }}>navbar holder</span>
        </div>
        <nav
          ref={navRef}
          onMouseLeave={() => onMouseOut()}
          className={
            "px-6 nav nav-height flex justify-between items-center mt-0 custom-navbar custom-nav-links-container " +
            (headerFixed ? (navFlex ? " nav-fixed " : " ") : " ") +
            (onhamburger ? " nav-active hamburger-active " : " ") +
            (showAcctPanel ? " acct-panel-open " : "") +
            (showCartPanel ? " cart-panel-open " : "") +
            languageDir
          }
          style={{ top: navTop + "rem" }}>
          <div className="nav-first flex justify-center items-center">
            <div className="nav-icon">
              <Link to="/" className="nav-logo-link">
                {lang === "ar" ? (
                  isDarkMode ? <>
                    <img data-src="/assets/logo/logo_AR.png" alt="hassan jameel" className="lazyload hidden d-md-inline" />
                    <img data-src="/assets/logo/logo_AR.png" alt="hassan jameel" className="lazyload d-inline d-md-hidden" /></>

                    : <> <img src="/assets/logo/hj-right.png" alt="logo" className="lazyload" width={250} height={250} />

                    </>
                ) : (
                  isDarkMode ?
                    <>
                      <img data-src="/assets/logo/logo_EN.png" alt="hassan jameel" className="lazyload hidden d-md-inline" />
                      <img data-src="/assets/logo/logo_EN.png" alt="hassan jameel" className="lazyload d-inline d-md-hidden" />
                    </>
                    : <>
                      <img src="/assets/logo/hj-left.png" alt="hassan jameel" className="lazyload" width={250} height={250} />
                    </>
                )}
              </Link>
            </div>

            {/* <div className="nav-desktop-cta hidden d-lg-flex">
              <Link to="/maintenance" className="nav-cta-btn">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                {trans("new:book_test_drive") || "Book Test Drive"}
              </Link>
            </div> */}

            <div onClick={() => setOnhamburger(false)} className={"nav-links text-black flex " + languageDir + (onhamburger ? " active" : " ")}>
              {partNavbar == false && (
                <>
                  <div className="mx-3">
                    <NavLink onMouseEnter={() => show(null)} onClick={() => show(null)} className="text-16 capitalize" to="/" exact>
                      {trans("home")}
                    </NavLink>
                  </div>
                  <div className={"nav-hide-sm "}>
                    <a href="#" onMouseEnter={() => show("vehicle")} onClick={() => show("vehicle")} className="text-16 capitalize cursor-pointer ">
                      {trans("vehicle")}
                    </a>
                  </div>
                  {brands &&
                    brands?.map((brand, index) => {
                      return (
                        <div className={" nav-show-sm"} key={index}>
                          <NavLink to={"/vehicles/" + brand.brand} className="text-16 capitalize cursor-pointer">
                            {brand.brand}
                          </NavLink>
                        </div>
                      );
                    })}

                  <div>
                    <div className={"onlinelinke"}>
                      <NavLink
                        onMouseEnter={() => show("Online_Cars_Store")}
                        onClick={() => show(null)}
                        className="text-16 capitalize"
                        activeClassName="active-online-link"
                        to="/VehicleOnline"
                      >
                        {trans("info:Online_Cars_Store")}
                      </NavLink>
                    </div>
                  </div>

                  <div>
                    <NavLink className="text-16 capitalize cursor-pointer" onMouseEnter={() => show("maintenance")} onClick={() => show(null)} to="/maintenance">
                      {trans("maintenance-services")}
                    </NavLink>
                  </div>

                  <div className={"nav-show-sm"}>
                    <NavLink className="text-16 capitalize cursor-pointer" style={{ paddingInlineStart: '2.5rem' }} to="/periodic-maintenance" onClick={() => setOnhamburger(false)}>
                      {trans("navbar:periodic_maintenance")}
                    </NavLink>
                  </div>

                  <div>
                    <NavLink onMouseEnter={() => show("offers")} onClick={() => show(null)} className="text-16 capitalize" to="/offers">
                      {trans("offers")}
                    </NavLink>
                  </div>

                  <div>
                    <NavLink onMouseEnter={() => show("finance")} onClick={() => show(null)} className="text-16 capitalize" to="/finance">
                      {trans("home:finance")}
                    </NavLink>
                  </div>
                  <div>
                    <NavLink onMouseEnter={() => show(null)} onClick={() => show(null)} className="text-16 capitalize" to="/recruitment">
                      {trans("employment")}
                    </NavLink>
                  </div>
                  <div>
                    <NavLink onMouseEnter={() => show("about")} onClick={() => show(null)} className="text-16 capitalize" to="/about">
                      {trans("about-us")}
                    </NavLink>
                  </div>
                  <div>
                    <NavLink onMouseEnter={() => show("contact")} onClick={() => show(null)} className="text-16 capitalize" to="/contact">
                      {trans("contact-us")}
                    </NavLink>
                  </div>
                </>
              )}
              <div className="nav-mobile-extras nav-show-sm">
                <div className="nav-mobile-section-title">{trans("info:settings") || "Settings"}</div>

                <div className="nav-mobile-settings-grid">
                  {/* Search Item */}
                  <div className="nav-mobile-setting-item">
                    <Link to="/search" className="nav-mobile-setting-circle" onClick={() => setOnhamburger(false)}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                    </Link>
                  </div>

                  {/* Language Switcher Item */}
                  <div className="nav-mobile-setting-item">
                    <button
                      className="nav-mobile-setting-circle"
                      onClick={(e) => {
                        e.preventDefault();
                        setOnhamburger(false);
                        if (window.location.href.includes("/ar") || window.location.href.includes("/en")) {
                          if (window.location.href.includes("/en")) window.location = window.location.href.replace("/en", "/ar");
                          else if (window.location.href.includes("/ar")) window.location = window.location.href.replace("/ar", "/en");
                        } else {
                          window.location = window.location.origin + "/en" + window.location.pathname + window.location.search;
                        }
                      }}
                    >
                      <img src={lang === 'ar' ? "/assets/flags/united-kingdom.svg" : "/assets/flags/ksa.svg"} className="flag-icon" alt="change language" />
                    </button>
                  </div>

                  {/* Dark Mode Toggle Item */}
                  <div className="nav-mobile-setting-item">
                    <button className="nav-mobile-setting-circle" onClick={() => { toggleDarkMode(); setOnhamburger(false); }}>
                      {isDarkMode ? (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
                      ) : (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
                      )}
                    </button>
                  </div>

                  {/* Call Center Item */}
                  <div className="nav-mobile-setting-item">
                    <a href="tel:920018996" className="nav-mobile-setting-circle">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                    </a>
                  </div>

                  {/* Notifications Item (Mobile Only) */}
                  {localStorage.getItem("isAuthenticated") && (
                    <div className="nav-mobile-setting-item">
                      <Link to="/user/notifications" className="nav-mobile-setting-circle relative" onClick={() => setOnhamburger(false)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                        {notificationCount > 0 && (
                          <div className="notification-bubble-v7">
                            {notificationCount > 99 ? "+99" : notificationCount}
                          </div>
                        )}
                      </Link>
                    </div>
                  )}
                </div>

                {localStorage.getItem("isAuthenticated") && (
                  <>
                    <div className="nav-mobile-user-profile-card mt-6">
                      <div className="nav-mobile-user-profile-info">
                        <div className="nav-mobile-user-profile-avatar">
                          {userInfo ? (
                            (userInfo[`FirstName${lang === 'ar' ? 'Ar' : 'En'}`] || userInfo[`${lang}FirstName`] || "U")[0].toUpperCase()
                          ) : (
                            (localStorage.getItem("userName") || "U")[0].toUpperCase()
                          )}
                        </div>
                        <div className="nav-mobile-user-profile-details">
                          <div className="nav-mobile-user-profile-name">
                            {userInfo ? (
                              `${userInfo[`FirstName${lang === 'ar' ? 'Ar' : 'En'}`] || userInfo[`${lang}FirstName`] || ""} ${userInfo[`LastName${lang === 'ar' ? 'Ar' : 'En'}`] || userInfo[`${lang}LastName`] || ""}`
                            ) : (
                              localStorage.getItem("userName") || trans("info:profile")
                            )}
                          </div>
                          <div className="nav-mobile-user-profile-sub">
                            {userInfo?.email || userInfo?.phone || localStorage.getItem("userPhone") || ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="nav-mobile-logout-wrapper mt-4">
                      <LogoutButtonV7 className="nav-mobile-logout-btn" />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="flex h-full items-center">
            <div className="nav-btns flex flex-row justify-center items-center space-x-2 space-x-reverse ">
              {partNavbar == true ? (
                <CartIconWithPopover linkToCart="/parts/cart" />
              ) : (
                <div
                  className={"relative btn-cart flex flex-col"}
                  onMouseEnter={() => {
                    if (window.innerWidth > 992 && getCartList().length > 0) setShowCartNotification(true);
                  }}>
                  <div
                    className={"cart-badge"}
                    style={{
                      lineHeight: 1.5,
                      zIndex: 1,
                      animation: countlist > 0 ? 'badgeBounce 2s infinite ease-in-out' : 'none'
                    }}
                  >
                    {countlist}
                  </div>
                  <Link
                    className={(!navFlex && onhamburger ? "open" : "") + " btn-cart-link"}
                    to={window.innerWidth > 992 ? "/cart" : "#"}
                    onClick={(e) => {
                      if (window.innerWidth <= 992) {
                        e.preventDefault();
                        setShowCartNotification(false);
                        setShowAcctPanel(false);
                        setShowCartPanel(v => !v);
                      }
                    }}
                  >
                    <img
                      data-src={cartCount === 0 ? "/assets/icons/cart-nothing.svg" : "/assets/icons/cart.svg"}
                      className="lazyload cart-icon-img"
                      alt="cart"
                    />
                  </Link>

                  {/* Cart Panel Bottom Sheet (Mobile) */}
                  {
                    showCartPanel && (
                      <>
                        <div className="nav-cart-backdrop" onClick={() => setShowCartPanel(false)} />
                        <div
                          className={"nav-cart-panel " + languageDir}
                          dir={lang === 'ar' ? 'rtl' : 'ltr'}
                          onTouchStart={handleTouchStart}
                          onTouchMove={handleTouchMove}
                          onTouchEnd={handleTouchEnd}
                          style={currentY > 0 ? { transform: `translateY(${currentY}px)`, transition: 'none' } : {}}
                        >
                          <button className="nav-cart-close nav-show-sm" onClick={() => setShowCartPanel(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                              <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                          </button>
                          <div className="nav-cart-head">
                            <h3 className="nav-cart-title">{trans("cartFile:Cart_content") || trans("cart")}</h3>
                            <span className="nav-cart-count">{countlist} {trans("new:pieces") || trans("items")}</span>
                          </div>
                          <div className="nav-cart-products">
                            {getCartList()?.map((data, index) => (
                              <div key={index} className="nav-cart-item">
                                <img
                                  className="nav-cart-item-img"
                                  src={data?.image ? (data.image.startsWith("http") || data.image.startsWith("data:image") ? data.image : (Base64.isValid(data.image) || (!data.image.includes("/") && !data.image.includes(".")) ? "data:image/png;base64," + data.image : (data.image.startsWith("/") ? config.mainURL + data.image : config.mainURL + "/" + data.image))) : "/assets/images/default.png"}
                                  alt={data?.name || "product"}
                                />
                                <div className="nav-cart-item-info">
                                  <div className="nav-cart-item-name">{(data?.Type?.toLowerCase() === "car" || !data?.name) ? (lang === "ar" ? `${data?.brand || ''} ${data?.modelTypes || ''} ${data?.year || ''}` : `${data?.brandEn || ''} ${data?.modelTypesEn || ''} ${data?.year || ''}`).trim() : (lang === "ar" ? data?.name : data?.nameEn)}</div>
                                  <div className="nav-cart-item-price"><Price price={data?.price} className="text-2xl text-[#23cc4f]" /></div>
                                </div>
                              </div>
                            ))}
                            {getCartList()?.length === 0 && (
                              <div className="nav-cart-empty">
                                <img src="/assets/icons/cart-empty.svg" alt="empty" style={{ width: '60px', opacity: 0.3, marginBottom: '15px' }} />
                                <p className="text-14 font-bold opacity-60">{trans("empty-cart")}</p>
                              </div>
                            )}
                          </div>
                          {getCartList()?.length > 0 && (
                            <div className="nav-cart-footer">
                              {fullTotal && (
                                <div className="flex justify-between items-center mb-4 px-1">
                                  <span className="text-13 font-bold opacity-70">{trans("new:total")}</span>
                                  <span className="text-16 font-extrabold text-primary">{numberFormat(fullTotal)}</span>
                                </div>
                              )}
                              <Link to="/cart" className="cart-view-btn" onClick={() => setShowCartPanel(false)}>
                                {trans("cartFile:View_cart") || "View Cart"}
                              </Link>
                            </div>
                          )}
                        </div>
                      </>
                    )
                  }

                  <div
                    ref={popRef}
                    className={"cart-notification " + languageDir + (showCartNotification ? " show " : " hidden ")}
                    onMouseLeave={() => setShowCartNotification(false)}
                  >
                    <div className="cart-notification-header">
                      <h3>{trans("cartFile:Cart_content") || trans("cart")}</h3>
                      <span className="text-12 font-bold opacity-60">
                        {countlist} {trans("new:pieces") || trans("items")}
                      </span>
                    </div>

                    <div className="cart-notification-products">
                      {getCartList()?.slice(0, 4).map((data, index) => (
                        <div key={index} className="cart-item">
                          <img
                            className="cart-item-img"
                            src={data?.image ? (data.image.startsWith("http") || data.image.startsWith("data:image") ? data.image : (Base64.isValid(data.image) || (!data.image.includes("/") && !data.image.includes(".")) ? "data:image/png;base64," + data.image : (data.image.startsWith("/") ? config.mainURL + data.image : config.mainURL + "/" + data.image))) : "/assets/images/default.png"}
                            alt={data?.name || "product"}
                          />
                          <div className="cart-item-info">
                            <div className="cart-item-name">
                              {(data?.Type?.toLowerCase() === "car" || !data?.name) ? (lang === "ar" ? `${data?.brand || ''} ${data?.modelTypes || ''} ${data?.year || ''}` : `${data?.brandEn || ''} ${data?.modelTypesEn || ''} ${data?.year || ''}`).trim() : (lang === "ar" ? data?.name : data?.nameEn)}
                            </div>
                            <div className="cart-item-price">
                              <Price price={data?.price} className="text-2xl text-[#23cc4f]" />
                            </div>
                          </div>
                        </div>
                      ))}
                      {getCartList()?.length > 4 && (
                        <div className="p-3 text-center text-12 font-bold opacity-50">
                          + {getCartList().length - 4} {trans("more_items") || "more items"}
                        </div>
                      )}

                      {getCartList()?.length === 0 && (
                        <div className="p-10 text-center">
                          <img src="/assets/icons/cart-empty.svg" alt="empty" style={{ width: '60px', opacity: 0.3, marginBottom: '15px' }} />
                          <p className="text-14 font-bold opacity-60">{trans("empty-cart")}</p>
                        </div>
                      )}
                    </div>

                    {getCartList()?.length > 0 && (
                      <div className="cart-notification-footer">
                        {fullTotal && (
                          <div className="flex justify-between items-center mb-4 px-1">
                            <span className="text-12 font-bold opacity-70">{trans("new:total")}</span>
                            <span className="text-15 font-extrabold text-primary">{numberFormat(fullTotal)}</span>
                          </div>
                        )}
                        <Link to="/cart" className="cart-view-btn" onClick={() => setShowCartNotification(false)}>
                          {trans("cartFile:View_cart") || "View Cart"}
                        </Link>
                      </div>
                    )}
                  </div>

                </div>
              )}
              {/* ── Account Dropdown Panel ─────────────────────── */}
              <div className="nav-acct-dropdown" style={{ position: 'relative' }}>
                <button
                  className="nav-acct-trigger nav-acct-trigger-mobile"
                  onClick={() => {
                    setShowCartPanel(false);
                    setShowAcctPanel(v => !v);
                  }}
                  aria-label="Account"
                >
                  <img
                    src={"/assets/icons/user.svg"}
                    alt="user profile"
                  />
                </button>

                {/* Account Panel Dropdown / Bottom Sheet */}
                {
                  showAcctPanel && (
                    <>
                      <div className="nav-acct-backdrop" onClick={() => setShowAcctPanel(false)} />
                      <div
                        className={"nav-acct-panel " + languageDir}
                        dir={lang === 'ar' ? 'rtl' : 'ltr'}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        style={currentY > 0 ? { transform: `translateY(${currentY}px)`, transition: 'none' } : {}}
                      >
                        <button className="nav-acct-close nav-show-sm" onClick={() => setShowAcctPanel(false)}>
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                        </button>
                        {!localStorage.getItem("isAuthenticated") ? (
                          <div className="nav-acct-head">
                            <p className="nav-acct-welcome">
                              {(lang === 'ar' ? "مرحباً بك في حسن جميل" : "Welcome to Hassan Jameel")
                                .split(' ')
                                .map((word, i, arr) =>
                                  i >= arr.length - 2 ? (
                                    <span key={i} className="gn">{word} </span>
                                  ) : (
                                    word + ' '
                                  )
                                )}
                            </p>                            <button className="nav-acct-signin" onClick={() => { setShowAcctPanel(false); setActivePopUpModel({ tab: 1, title: "sign-in" }); handlePopupStatus(true); }}>
                              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4" /><polyline points="10 17 15 12 10 7" /><line x1="15" y1="12" x2="3" y2="12" /></svg>
                              {trans("info:login") || "Sign In"}
                            </button>
                            <button className="nav-acct-create" onClick={() => { setShowAcctPanel(false); setActivePopUpModel({ tab: 2, title: "sign-up" }); handlePopupStatus(true); }}>
                              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="8.5" cy="7" r="4" /><line x1="20" y1="8" x2="20" y2="14" /><line x1="23" y1="11" x2="17" y2="11" /></svg>
                              {trans("info:register") || "Create Account"}
                            </button>
                          </div>
                        ) : (
                          <div className="nav-acct-head nav-acct-head--logged">
                            <div className="nav-acct-user-info">
                              <div className="nav-acct-avatar">
                                {userInfo ? (
                                  (userInfo[`FirstName${lang === 'ar' ? 'Ar' : 'En'}`] || userInfo[`${lang}FirstName`] || "U")[0].toUpperCase()
                                ) : (
                                  (localStorage.getItem("userName") || "U")[0].toUpperCase()
                                )}
                              </div>
                              <div className="nav-acct-details">
                                <div className="nav-acct-name">
                                  {userInfo ? (
                                    `${userInfo[`FirstName${lang === 'ar' ? 'Ar' : 'En'}`] || userInfo[`${lang}FirstName`] || ""} ${userInfo[`LastName${lang === 'ar' ? 'Ar' : 'En'}`] || userInfo[`${lang}LastName`] || ""}`
                                  ) : (
                                    localStorage.getItem("userName") || trans("info:profile") || "My Account"
                                  )}
                                </div>
                                <Link to="/user" className="nav-acct-profile-link" onClick={() => setShowAcctPanel(false)}>
                                  {lang === 'ar' ? "عرض الملف الشخصي" : "View Profile"}
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '12px', height: '12px', marginInlineStart: '4px' }}><polyline points="9 18 15 12 9 6"></polyline></svg>
                                </Link>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="nav-acct-links">
                          <Link to={localStorage.getItem("isAuthenticated") ? "/user/myBookings" : "#"} className="nav-acct-link" onClick={(e) => { if (!localStorage.getItem("isAuthenticated")) { e.preventDefault(); setShowAcctPanel(false); setActivePopUpModel({ tab: 1, title: "sign-in" }); handlePopupStatus(true); } else { setShowAcctPanel(false); } }}>
                            <div className="nav-acct-icon-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" /></svg></div>
                            <div className="nav-acct-text"><span className="nav-acct-link-title">{trans("common:service_history") || "Service History"}</span><span className="nav-acct-link-sub">{trans("common:view_past_appointments") || "View past appointments"}</span></div>
                          </Link>
                          <Link to="/finance" className="nav-acct-link" onClick={() => setShowAcctPanel(false)}>
                            <div className="nav-acct-icon-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" /></svg></div>
                            <div className="nav-acct-text"><span className="nav-acct-link-title">{trans("common:finance") || "My Financing"}</span><span className="nav-acct-link-sub">{trans("common:payments_statements") || "Payments & statements"}</span></div>
                          </Link>
                          <Link to={localStorage.getItem("isAuthenticated") ? "/user/favorite" : "#"} className="nav-acct-link" onClick={(e) => { if (!localStorage.getItem("isAuthenticated")) { e.preventDefault(); setShowAcctPanel(false); setActivePopUpModel({ tab: 1, title: "sign-in" }); handlePopupStatus(true); } else { setShowAcctPanel(false); } }}>
                            <div className="nav-acct-icon-box"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" /></svg></div>
                            <div className="nav-acct-text"><span className="nav-acct-link-title">{trans("common:saved_vehicles") || "Saved Vehicles"}</span><span className="nav-acct-link-sub">{trans("common:your_wishlist") || "Your wishlist"}</span></div>
                          </Link>
                        </div>
                        {localStorage.getItem("isAuthenticated") && (
                          <div className="nav-acct-logout-footer">
                            <LogoutButtonV7 className="nav-acct-logout-btn" />
                          </div>
                        )}
                      </div>
                    </>
                  )
                }
              </div>

              {/* Search Link */}
              <Link to="/search" className="nav-acct-trigger nav-search-btn-desktop hidden d-lg-flex" title={trans("info:search")}>
                <img className={"lazyload"} data-src="/assets/icons/search.svg" alt="search" />
              </Link>

              {/* Call Center */}
              {showCallCenter && (
                <a href="tel:920018996" className="nav-call-btn hidden d-lg-flex">
                  <img className="lazyload" data-src="/assets/icons/phone.svg" alt="call center" />
                  <span className="hidden d-lg-block">9200 18996</span>
                </a>
              )}

              {/* Notifications */}
              {localStorage.getItem("isAuthenticated") && <NotificationComponent />}

              {/* Dark Mode Toggle */}
              <button onClick={toggleDarkMode} className="nav-acct-trigger theme-toggle-btn hidden d-lg-flex" title={isDarkMode ? "Light Mode" : "Dark Mode"}>
                {isDarkMode ? (
                  <img src="/assets/icons/sun.svg" alt="Light Mode" style={{ width: "18px", height: "18px", filter: "brightness(0) invert(1)" }} />
                ) : (
                  <img src="/assets/icons/moon.svg" alt="Dark Mode" style={{ width: "18px", height: "18px", filter: "brightness(0)" }} />
                )}
              </button>

              {/* Language Dropdown */}
              <div className="nav-lang-dropdown relative hidden d-lg-flex">
                <button
                  className="nav-lang flex justify-between items-center cursor-pointer px-1 px-md-3"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowLangPanel(!showLangPanel);
                  }}
                  type="button"
                >
                  <div className="flex items-center">
                    {lang.startsWith('ar') ? (
                      <img className="flag-icon" src="/assets/flags/ksa.svg" alt="AR" />
                    ) : (
                      <img className="flag-icon" src="/assets/flags/united-kingdom.svg" alt="EN" />
                    )}
                    <span className="text-black text-14 font-bold mx-2 capitalize hidden d-md-inline">{lang.startsWith('ar') ? 'العربية' : 'English'}</span>
                  </div>
                  <svg className={"lang-arrow hidden d-md-inline " + (showLangPanel ? " rotate-180 " : "")} width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#111827" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>

                {showLangPanel && (
                  <>
                    <div
                      className="nav-lang-backdrop"
                      style={{ position: 'fixed', inset: 0, zIndex: 9998 }}
                      onClick={() => setShowLangPanel(false)}
                    />
                    <div className={"nav-lang-menu custom-shadow show " + languageDir} style={{ display: 'block' }}>
                      <a
                        className={`lang-item ${lang.startsWith('ar') ? 'active-lang' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setShowLangPanel(false);
                          if (!lang.startsWith('ar')) {
                            const currentPathname = window.location.pathname;
                            const newPathname = currentPathname.match(/^\/(en|ar)(\/|$)/)
                              ? currentPathname.replace(/^\/(en|ar)(\/|$)/, '/ar$2')
                              : '/ar' + currentPathname;
                            window.location.href = window.location.origin + newPathname + window.location.search;
                          }
                        }} >
                        <img src="/assets/flags/ksa.svg" className="flag-icon" alt="AR" />
                        <span className="font-bold mb-0">العربية</span>
                      </a>
                      <a className={`lang-item ${lang.startsWith('en') ? 'active-lang' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setShowLangPanel(false);
                          if (!lang.startsWith('en')) {
                            const currentPathname = window.location.pathname;
                            const newPathname = currentPathname.match(/^\/(en|ar)(\/|$)/)
                              ? currentPathname.replace(/^\/(en|ar)(\/|$)/, '/en$2')
                              : '/en' + currentPathname;
                            window.location.href = window.location.origin + newPathname + window.location.search;
                          }
                        }} >
                        <img src="/assets/flags/united-kingdom.svg" className="flag-icon" alt="EN" />
                        <span className="font-bold mb-0">English</span>
                      </a>
                    </div>
                  </>
                )}
              </div>

              {/* Hamburger */}
              <div className={"hamburger " + (onhamburger ? "open" : "")} onClick={() => setOnhamburger(!onhamburger)}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          <div
            className={"nav-mega " + languageDir}
          // onMouseLeave={() => {
          //     onMouseOut();
          // }}
          >
            {showedListNav.includes("vehicle") && <NavCar className={showNav === "vehicle" || "hidden"} onClick={() => show(null)} />}
            {showedListNav.includes("maintenance") && <NavMaintenance className={showNav === "maintenance" || "hidden"} />}

            {/* <NavParts className={(showNav === "epart" || "hidden")} /> */}

            {showedListNav.includes("about") && <NavAbout className={showNav === "about" || "hidden"} />}
            {showedListNav.includes("contact") && <NavContact className={showNav === "contact" || "hidden"} schema={schemaNavContact} />}
          </div>
        </nav>
      </header>
      {/* All navbar styles are in _navbar.scss */}
      <Popup show={showPopup}>
        <div className="custom-popup-wrapper" onClick={(e) => {
          if (e.target === e.currentTarget) handlePopupStatus(false);
        }}>
          <div className="custom-popup-container">
            <button
              className={`modal-close bg-white dark:bg-vblack shadow-sm !m-0 ${lang === 'ar' ? '!left-4 !right-auto' : '!right-4 !left-auto'}`}
              style={{ zIndex: 9999 }}
              onClick={() => handlePopupStatus(false)}
            >✕</button>

            {/* Image & Brand Side */}
            <div className={`custom-popup-image-side ${languageDir}`} style={{ backgroundImage: "url('/assets/images/bg-hj.png')" }}>

              <div className="custom-popup-image-content-overlay" key={activePopUpModel.tab}>
                <h2>
                  {activePopUpModel.tab == 1 ? (lang === 'ar' ? 'مرحباً بك' : 'Welcome Back') :
                    activePopUpModel.tab == 2 ? (lang === 'ar' ? 'إنشاء حساب جديد' : 'Create Account') :
                      activePopUpModel.tab == 3 ? (lang === 'ar' ? 'نسيت كلمة المرور' : 'Reset Password') :
                        (lang === 'ar' ? 'التحقق' : 'Validation')}
                </h2>
                <p>
                  {activePopUpModel.tab == 1 ? (lang === 'ar' ? 'سجّل دخولك لمتابعة استخدام حسابك' : 'Sign in to continue to your account') :
                    activePopUpModel.tab == 2 ? (lang === 'ar' ? 'انضم إلينا اليوم للحصول على أفضل الخدمات' : 'Join us today to get the best services') :
                      activePopUpModel.tab == 3 ? (lang === 'ar' ? 'أدخل بياناتك لاستعادة الوصول لحسابك' : 'Enter your details to regain access') :
                        (lang === 'ar' ? 'مرحباً بك مجدداً' : 'Welcome back again')}
                </p>
              </div>

            </div>

            {/* Form Side */}
            <div className={`custom-popup-form-side ${languageDir}`}>

              <div className="custom-popup-top-tabs">
                <button
                  className={activePopUpModel.tab == 1 ? 'active' : ''}
                  onClick={() => handleTabChange({ tab: 1, title: 'sign-in' })}
                >
                  {trans("form:sign-in")}
                </button>
                <button
                  className={activePopUpModel.tab == 2 ? 'active' : ''}
                  onClick={() => handleTabChange({ tab: 2, title: 'sign-up' })}
                >
                  {trans("form:sign-up")}
                </button>
              </div>

              <div className="custom-popup-scroll">
                {activePopUpModel.tab == 1 ? (
                  <SignIn
                    onTabChange={(tab) => handleTabChange(tab)}
                    onLogin={() => handlePopupStatus(false)}
                  />
                ) : activePopUpModel.tab == 2 ? (
                  <SignUp
                    onTabChange={(tab) => handleTabChange(tab)}
                    onLogin={() => handlePopupStatus(false)}
                  />
                ) : activePopUpModel.tab == 3 ? (
                  <ResetPassword
                    onTabChange={(tab) => handleTabChange(tab)}
                  />
                ) : (
                  <LoginValidation
                    onTabChange={(tab) => handleTabChange(tab)}
                    onLogin={() => handlePopupStatus(false)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Popup>
      <AdvancedSearch
        show={searchPopup}
        onSearchClick={(value) => {
          setSearchPopup(value);
        }}
      />

    </Fragment >
  );
}

export default Navbar;